import type { SVGProps } from 'react'
const SvgSyBankSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="M1.2 20.6h21.6v2.2H1.2zM3.4 12h2.2v7.5H3.4zm5.4 0H11v7.5H8.8zm4.3 0h2.2v7.5h-2.2zm5.4 0h2.2v7.5h-2.2zM1.2 6.6 12 1.2l10.8 5.4v4.3H1.2zm2.2 1.3v.8h17.3v-.8L12 3.6zm8.6-.2c-.6 0-1.1-.5-1.1-1.1s.5-1.1 1.1-1.1 1.1.5 1.1 1.1-.5 1.1-1.1 1.1" />
	</svg>
)
export default SvgSyBankSystem
